import { Tag, Tooltip } from "antd";
import { useTranslation } from "react-i18next";

interface Props {
  isManual: boolean;
  note?: string;
}

export const ManualMovementTag = ({ isManual, note }: Props) => {
  const { t } = useTranslation();

  if (!isManual) {
    return null;
  }

  return (
    <Tooltip title={note}>
      <span>
        <Tag color="geekblue" style={{ marginRight: 0 }}>
          {t("commissions.bailAccount.helpers.manualMovement")}
        </Tag>
      </span>
    </Tooltip>
  );
};
